import * as Yup from 'yup'

type CustomStakeholder = {
  email: string
}

const stakeholderEmailValidateRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const offerStakeholdersValidation = {
  offerStakeholders: Yup.array()
    .of(
      Yup.object().shape({
        email: Yup.string().required('Email cannot be empty.'),
      })
    )
    .min(1, 'At least one stakeholder is required.'),

  customOfferStakeholders: Yup.array().test(
    'Enter-valid-emails',
    'Enter valid emails.',
    function (value?: CustomStakeholder[]) {
      if (!value) return true
      return value.every(v => stakeholderEmailValidateRegex.test(v.email))
    }
  ),
}

export const customStakeholdersValidation = Yup.object().shape({
  customOfferStakeholders: Yup.array().test(
    'Enter-valid-emails',
    'Enter valid emails',
    function (value?: CustomStakeholder[]) {
      if (!value) return true
      return value.every(v => stakeholderEmailValidateRegex.test(v.email))
    }
  ),
})
